<template>
  <div>
    <router-view></router-view>
    <ConfirmModal ref="confirm-modal"/>
    <Chat/>
    <PermissionListener/>
  </div>
</template>

<script>
import {ApiException, Notification, ValidationError} from "@/domain/core/exception/exceptions";
import ConfirmModal from "./components/ConfirmModal.vue";
import {mapActions} from 'vuex'
import Chat from "@/domain/chat/Chat.vue";
import PermissionListener from "@/domain/login/components/PermissionListener.vue";

export default {
  name: 'App',
  components: {Chat, ConfirmModal, PermissionListener},
  mounted (){
    this.setConfirmModal(this.$refs['confirm-modal'])
  },
  methods: {
    ...mapActions('notifications', ['setConfirmModal']),
  },
  errorCaptured(err, vm, info) {
    if (err instanceof Notification) {
      this.notifyMessage({text: err.message, messageType: err.type})
    } else if (err instanceof ValidationError) {
      this.notifyMessage({text: err.getPrettyMessage(), messageType: 'danger'})
    } else if (err instanceof ApiException) {
      this.notifyMessage({text: this.getErrorMessage(err), messageType: 'danger'})
    } else {
      console.log('errorCaptured', err, vm, info);
    }
    return false;
  },
  getErrorMessage(err) {
    const message = err.message
    // Se il messaggio è un oggetto con proprietà leggibili, prova a estrarre un messaggio
    if (message && typeof message === 'object') {
      if (message.detail) return message.detail
      if (message.message) return message.message
      if (message.error) return message.error
    }
    // Se il messaggio è una stringa che sembra HTML, ritorna un messaggio generico
    if (typeof message === 'string') {
      const trimmed = message.trim()
      if (trimmed.startsWith('<') || trimmed.startsWith('<!')) {
        return 'An unexpected error occurred'
      }
      return message
    }
    return 'An unexpected error occurred'
  }
}
</script>

<style lang="scss">
// Import Main styles for this application
@import 'assets/scss/style';
</style>
